import gql from 'graphql-tag'

export const fetchSuggestedCartQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_uid: [String]
    $pack_format: [String]
    $filter_packaging: [String]
    $dimension: [String],
    $ship_tos: [String]
  ) {
  getSuggestedCarts(
    search: $search,
    ship_tos: $ship_tos
    filter: {
      sku: { in: $sku }
      brand: { in: $brand }
      pack_format: {in : $pack_format}
      category_uid: { in: $category_uid }
      filter_packaging: { in: $filter_packaging }
      dimension: { in: $dimension }
    }
    sort: $sort
  ) {
    has_packages
    items {
      summary_total_amount_wo_vat
      summary_total_amount_to_pay_for_goods
      summary_total_empty_deposit
      suggested_cart_total
      shipping_address {
        payer_name
        outlet_name
        street
        city
        country
        province
        postalcode
        sap_id
      }
      products {
        sku
        image
        name
        number_of_items_on_pallet
        number_of_items_on_layer
        total_units
        units
        number_of_layers
        number_of_pallets
        price_per_piece
        your_price_wo_vat
        your_price_w_vat
        redemption_fee
        multi_deposit_z099
        is_in_flexible_package
        tags {
          value
          label
          color
        }
      }
    }
    aggregations {
      attribute_code
      count
      label
      options {
        label
        value
        count
      }
    }
  }
}
`
